module.exports = __webpack_public_path__ + "static/step1-element-8a6b07a288a76cd059ab9d861bdd0474.png";